import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Specialties", href: "/#specialties" },
  { label: "Treatments", href: "/#treatments" },
  { label: "About", href: "/#about" },
  { label: "Telehealth", href: "/#telehealth" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/#contact" },
];

export const Navbar = ({ onBookClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FDFCF8]/80 backdrop-blur-xl border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center group"
        >
          <img
            src="/logo.jpg"
            alt="Neurological Communication Partners"
            className="h-14 md:h-16 w-auto rounded-xl ring-1 ring-black/5 group-hover:ring-[#739072]/40 transition"
          />
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                href={l.href}
                className="link-underline text-sm tracking-wide text-[#2D332F]/80 hover:text-[#2D332F] transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          data-testid="nav-cta-consult"
          onClick={onBookClick}
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#2D332F] text-[#FDFCF8] text-sm tracking-wide hover:bg-[#739072] transition-colors duration-300"
        >
          Book a Consult
        </button>

        <button
          data-testid="nav-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-full hover:bg-black/5 transition"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-[#FDFCF8]/95 backdrop-blur-xl">
          <ul className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block text-base text-[#2D332F]/80"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <button
                data-testid="mobile-nav-cta"
                onClick={() => {
                  setOpen(false);
                  onBookClick && onBookClick();
                }}
                className="inline-flex px-5 py-2.5 rounded-full bg-[#2D332F] text-[#FDFCF8] text-sm"
              >
                Book a Consult
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};
